import { Component, inject, resource, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCard } from '../../shared/components/app-card/app-card';
import { StatisticsService } from '../../core/services/statistics.service';
import { firstValueFrom } from 'rxjs';
import { AppSectionHeader } from "../../shared/components/app-section-header/app-section-header";
import { AppButton } from '../../shared/components/app-button/app-button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-system-dashboard',
  standalone: true,
  imports: [CommonModule, AppCard, AppSectionHeader, AppButton, RouterLink],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './system-dashboard.html',
})
export class SystemDashboard {
  private statsService = inject(StatisticsService);

  statsResource = resource({
    loader: async () => {
      try {
        return await firstValueFrom(this.statsService.getSystemDashboardStats());
      } catch (e) {
        console.error('Error loading system stats', e);
        return null;
      }
    }
  });

  get maxChartValue(): number {
    const data = this.statsResource.value()?.chartData || [];
    if (data.length === 0) return 10;
    return Math.max(...data.map((d: any) => d.value), 10);
  }

  handleReload() {
    this.statsResource.reload();
  }
}
